import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW0800Module } from '../../../commons/kymw08/kymw0800/kymw0800.module';
import { KYMW0900Module } from '../../../commons/kymw09/kymw0900/kymw0900.module';
import { KYMW0903Module } from '../../../commons/kymw09/kymw0903/kymw0903.module';
import { KYMW0A00Module } from '../../../commons/kymw0a/kymw0a00/kymw0a00.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1400KomaPageLeftModule } from '../kymw1400/kymw1400-koma-page-left/kymw1400-koma-page-left.module';
import { KYMW1400KomaPageRightModule } from '../kymw1400/kymw1400-koma-page-right/kymw1400-koma-page-right.module';
import { KYMW1402Module } from '../kymw1402/kymw1402.module';
import { KYMW1403Module } from '../kymw1403/kymw1403.module';
import { KYMW1404Module } from '../kymw1404/kymw1404.module';
import { KYMW1406Module } from '../kymw1406/kymw1406.module';
import { KYMW1407Module } from '../kymw1407/kymw1407.module';
import { KYMW1409Module } from '../kymw1409/kymw1409.module';

import { KYMW1400Component } from './kymw1400.component';
import { PageLockService } from '../../../commons/kymw00/api-services/page-lock.service';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { DeleteAllKomaService } from './api-services/delete-all-koma.service';
import { DeleteKomaService } from './api-services/delete-koma.service';
import { DeletePublishVoiceService } from './api-services/delete-publish-voice.service';
import { GetKomaService } from './api-services/get-koma.service';
import { GetPageService } from './api-services/get-page.service';
import { GetPlanSummaryTableService } from './api-services/get-plan-summary-table.service';
import { LockKomaEditService } from './api-services/lock-koma-edit.service';
import { RegistGoodsService } from './api-services/regist-goods.service';
import { RegistKomaGoodsService } from './api-services/regist-koma-goods.service';
import { RegistKomaService } from './api-services/regist-koma.service';
import { ReplaceKomaService } from './api-services/replace-koma.service';
import { SetOrderNumSeqNoService } from './api-services/set-order-num-seq-no.service';
import { ShiftKomaService } from './api-services/shift-koma.service';
import { UpdateKomaService } from './api-services/update-koma.service';
import { KYMW1400KomaMediumComboBoxModule } from './kymw1400-koma-medium-combo-box/kymw1400-koma-medium-combo-box.module';
import { KYMW1422Module } from '../kymw1422/kymw1422.module';

/**
 * コマ割画面 モジュール設定クラス
 *
 * @export KYMW1400Module
 * @class KYMW1400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    KYMW0800Module,
    KYMW0900Module,
    KYMW0903Module,
    KYMW0A00Module,
    KYMW1400KomaMediumComboBoxModule,
    KYMW1400KomaPageLeftModule,
    KYMW1400KomaPageRightModule,
    KYMW1402Module,
    KYMW1403Module,
    KYMW1404Module,
    KYMW1406Module,
    KYMW1407Module,
    KYMW1409Module,
    KYMW1422Module

  ],
  declarations: [
    KYMW1400Component,
  ],
  providers: [
    PageLockService,
    PlanGoodsLockService,
    DeleteAllKomaService,
    DeleteKomaService,
    DeletePublishVoiceService,
    GetKomaService,
    GetPageService,
    GetPlanSummaryTableService,
    LockKomaEditService,
    RegistGoodsService,
    RegistKomaGoodsService,
    RegistKomaService,
    ReplaceKomaService,
    SetOrderNumSeqNoService,
    ShiftKomaService,
    UpdateKomaService,
  ],
})
export class KYMW1400Module {
}
